import React from 'react'
import styled from 'styled-components'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next'


export default function ChurchVerifySucess() {
  const { t } = useTranslation('settings')

  return (
    <ChurchVerifyCont>
        <CVText>{t('verification.submitted')}</CVText>
        <CheckCircleOutlineIcon 
                style={{
                    fontSize: '50px',
                    marginBottom: '30px',
                    color: 'green'
                }} />

        <CVText>{t('verification.reviewTime')}</CVText>
    </ChurchVerifyCont>
  )
}

const ChurchVerifyCont = styled.div`
        height: 100vh;
        width: 50vw;
        display: flex;
        flex-direction: column;
        width: fit-content;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: lighter;
        color: #4d4d4d;
        align-items: center;
`
const CVText = styled.div`
    width: 60%;
    
`
